import cookie from 'react-cookie';
import { createAction } from '../utils/actions';

export const CURRENCY_UPDATED = 'CURRENCY_UPDATED';

export function changeCurrency(currency) {
    return dispatch => {
        cookie.save('currency', currency, {path: '/'});
        dispatch(createAction(CURRENCY_UPDATED, currency));
    }
}



// WEBPACK FOOTER //
// ./src/currency/actions.js